module.exports = __webpack_public_path__ + "img/worksbot_img20022511.3815bc2a.jpg";